import { render, staticRenderFns } from "./AppleArbitrage.vue?vue&type=template&id=78af984c&"
import script from "./AppleArbitrage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppleArbitrage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports